function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "a",
  filterUnits: "userSpaceOnUse",
  x: 2.7,
  y: 2.7,
  width: 74,
  height: 74
}, React.createElement("feColorMatrix", {
  values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
})));
var _ref3 = /*#__PURE__*/React.createElement("mask", {
  maskUnits: "userSpaceOnUse",
  x: 2.7,
  y: 2.7,
  width: 74,
  height: 74,
  id: "b"
}, React.createElement("path", {
  d: "M39.7 68.7c16 0 29-13 29-29s-13-29-29-29-29 13-29 29 13 29 29 29zm0 4c18.2 0 33-14.8 33-33s-14.8-33-33-33-33 14.8-33 33 14.7 33 33 33z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff",
  filter: "url(#a)"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M64.7 39.7c0 13.8-11.2 25-25 25v8c18.2 0 33-14.8 33-33h-8zm-25-25c13.8 0 25 11.2 25 25h8c0-18.2-14.8-33-33-33v8zm-25 25c0-13.8 11.2-25 25-25v-8c-18.2 0-33 14.8-33 33h8zm25 25c-13.8 0-25-11.2-25-25h-8c0 18.2 14.8 33 33 33v-8zm29-25c0 16-13 29-29 29v8c20.4 0 37-16.6 37-37h-8zm-29-29c16 0 29 13 29 29h8c0-20.4-16.6-37-37-37v8zm-29 29c0-16 13-29 29-29v-8c-20.4 0-37 16.6-37 37h8zm29 29c-16 0-29-13-29-29h-8c0 20.4 16.6 37 37 37v-8z",
  mask: "url(#b)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M58.7325 61.615l2.8284-2.8284 15.344 15.344-2.8284 2.8285zM22 39h4v14h-4zM30 34h4v19h-4zM38 28h4v25h-4zM46 37h4v16h-4zM54 34h4v19h-4z"
});
var SvgOverview = function SvgOverview(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    enableBackground: "new 0 0 84 84",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOverview, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/overview.431e4e96.svg";
export { ForwardRef as ReactComponent };